<ion-item lines="none">
  <ion-label position="stacked">{{ label() }}</ion-label>
  <ion-input
    type="time"
    [formControl]="control()"
    [readonly]="readonly()"
    class="time-input"
  ></ion-input>
</ion-item>

@if (getErrorMessage()) {
  <div class="field-error">
    <span>{{ getErrorMessage() }}</span>
  </div>
}
